import AdminLayout from "../../components/layout/AdminLayout";
import AdminLinkSubmitForm from "../../components/admin/AdminLinkSubmitForm";

export default function AdminSubmitLinkPage() {
  return (
    <AdminLayout>
      <div className="max-w-3xl space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-slate-900" data-testid="admin-submit-link-title">
            Submit Link
          </h1>
          <p className="text-slate-600 mt-1">
            Import a product on behalf of a customer or into the general review queue.
          </p>
        </div>
        <AdminLinkSubmitForm redirectOnSuccess />
      </div>
    </AdminLayout>
  );
}
